var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBox"},[_c('commen-head'),_c('router-view'),_c('commen-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }